import { render } from "./FormaPagamento.vue?vue&type=template&id=97491946&ts=true"
import script from "./FormaPagamento.vue?vue&type=script&lang=ts"
export * from "./FormaPagamento.vue?vue&type=script&lang=ts"

import "./FormaPagamento.vue?vue&type=style&index=0&id=97491946&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__